const CollectionGridBrandHeader = (el) => {


  const initialize = () => {
    el.querySelector('.fs-more-button').addEventListener('click', () => {
      el.querySelector('.fs-texts p').classList.add('show')
      el.querySelector('.fs-more-button-row').classList.add('hide')
    })
  }


  initialize()

  return {
  }
}


export default CollectionGridBrandHeader
